import { CartAddEvent } from '@theme/events';

// Quick add for Offroad Prints product cards. Delegated so it keeps working
// after the theme editor re-renders a section.
if (!window.opQuickAddReady) {
  window.opQuickAddReady = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-op-quick-add')) return;

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.op-card__status');
    const root = window.Shopify?.routes?.root ?? '/';

    button.disabled = true;
    status.classList.remove('is-error');
    status.textContent = '';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      form.dispatchEvent(
        new CartAddEvent({}, form.id || 'op-quick-add', {
          source: 'op-quick-add',
          itemCount: cart.item_count,
          variantId: String(data.variant_id),
        })
      );
      status.textContent = 'Added to cart';
    } catch (error) {
      status.classList.add('is-error');
      status.textContent = error.message;
    } finally {
      button.disabled = false;
    }
  });
}
